<template>
  <v-card class="mx-auto mt-2" max-width="374" min-height="500" tile>
    <v-tabs style="color: #0070eb; fill: currentColor" color="accent" centered>
      <v-tabs-slider color="accent"></v-tabs-slider>
      <v-tab @click="swapElements"
        ><svg
          width="30px"
          height="26px"
          viewBox="0 0 30 26"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <title>box_opened</title>
          <g
            id="Workspace-Final"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g
              id="box_opened"
              transform="translate(-1.000000, -3.000000)"
              fill="currentColor"
            >
              <path
                d="M23.6601909,16.9852586 L23.6475242,16.9632586 L20.8921909,11.8839252 L26.5928576,11.8839252 L26.6055242,11.9059252 L29.3615242,16.9852586 L23.6601909,16.9852586 Z M20.5495242,27.6659252 L20.5495242,13.2872586 L22.9608576,17.7312586 C23.0468576,17.8885919 23.2068576,17.9865919 23.3795242,17.9865919 L25.7975242,17.9865919 L25.7988576,27.6659252 L20.5495242,27.6659252 Z M20.3675242,10.8465919 C20.3208576,10.4952586 20.2488576,10.1919252 20.1461909,9.91725857 L20.1415242,9.90525857 L20.1448576,9.89125857 L21.5521909,4.44525857 L21.5955242,4.45725857 L24.0875242,5.14992524 L24.0768576,5.19192524 L22.6061909,10.8839252 L20.3721909,10.8839252 L20.3675242,10.8465919 Z M19.5895242,27.6659252 L5.79085756,27.6659252 L5.79085756,17.9865919 L16.7581909,17.9865919 C16.9315242,17.9865919 17.0915242,17.8885919 17.1775242,17.7312586 L19.5895242,13.2872586 L19.5895242,27.6659252 Z M2.63752422,16.9852586 L2.67219089,16.9212586 L5.40685756,11.8839252 L19.2448576,11.8839252 L19.2108576,11.9472586 L16.4761909,16.9852586 L2.63752422,16.9852586 Z M9.28552422,6.59325857 L14.4381909,6.59325857 L14.4381909,7.88659191 L14.4175242,7.89859191 C13.4008576,8.54459191 12.7275242,9.61859191 12.5708576,10.8459252 L12.5655242,10.8839252 L9.28552422,10.8839252 L9.28552422,6.59325857 Z M16.4681909,8.28659191 L16.4708576,8.28659191 C17.9141909,8.28659191 19.1475242,9.35725857 19.4041909,10.8332586 L19.4128576,10.8839252 L13.5235242,10.8839252 L13.5328576,10.8332586 C13.7895242,9.35725857 15.0241909,8.28659191 16.4681909,8.28659191 L16.4681909,8.28659191 Z M30.6008576,17.7399252 C30.6875242,17.5859252 30.6881909,17.3945919 30.6041909,17.2405919 L27.2921909,11.1392586 C27.2075242,10.9812586 27.0468576,10.8832586 26.8735242,10.8832586 L23.6021909,10.8832586 L25.1415242,4.92459191 C25.2108576,4.65792524 25.0581909,4.38392524 24.8015242,4.31325857 L21.3355242,3.35125857 C21.2155242,3.31659191 21.0895242,3.33259191 20.9808576,3.39592524 C20.8655242,3.46259191 20.7835242,3.57192524 20.7495242,3.70459191 L19.4501909,8.72125857 L19.3961909,8.65925857 C18.6428576,7.78659191 17.5755242,7.28592524 16.4681909,7.28592524 C16.1588576,7.28592524 15.8361909,7.33525857 15.4535242,7.44125857 L15.3988576,7.45659191 L15.3988576,6.09325857 C15.3988576,5.81792524 15.1835242,5.59392524 14.9181909,5.59392524 L8.80552422,5.59259191 C8.54019089,5.59259191 8.32552422,5.81659191 8.32552422,6.09192524 L8.32552422,10.8832586 L5.12619089,10.8832586 C4.95285756,10.8832586 4.79219089,10.9812586 4.70685756,11.1392586 L1.39552422,17.2405919 C1.31085756,17.3945919 1.31285756,17.5859252 1.40019089,17.7399252 C1.48619089,17.8919252 1.64485756,17.9865919 1.81485756,17.9865919 L4.82952422,17.9865919 L4.82952422,28.1665919 C4.82952422,28.4432586 5.04552422,28.6665919 5.31019089,28.6665919 L26.2788576,28.6665919 C26.5435242,28.6665919 26.7588576,28.4432586 26.7588576,28.1665919 L26.7588576,17.9865919 L30.1861909,17.9865919 C30.3555242,17.9865919 30.5148576,17.8919252 30.6008576,17.7399252 L30.6008576,17.7399252 Z"
                id="Fill-1"
              ></path>
            </g>
          </g></svg
      ></v-tab>
      <v-tab @click="swapElements"
        ><svg
          width="30px"
          height="30px"
          viewBox="0 0 30 30"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <title>box_closed</title>
          <g
            id="Workspace-Final"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g
              id="box_closed"
              transform="translate(-1.000000, -1.000000)"
              fill="currentColor"
            >
              <path
                d="M2.33366667,29.6653333 L2.33366667,9.726 L12.4196667,9.726 L12.4196667,15.8846667 L19.5803333,15.8846667 L19.5803333,9.726 L29.6663333,9.726 L29.6663333,29.6653333 L2.33366667,29.6653333 Z M5.83833333,2.33466667 L13.3343333,2.33466667 L12.4823333,8.72466667 L2.643,8.72466667 L5.83833333,2.33466667 Z M13.4916667,8.72466667 L14.3436667,2.33466667 L17.6563333,2.33466667 L18.5083333,8.72466667 L13.4916667,8.72466667 Z M13.4203333,14.884 L18.579,14.884 L18.579,9.726 L13.4203333,9.726 L13.4203333,14.884 Z M29.357,8.72466667 L19.5176667,8.72466667 L18.6656667,2.33466667 L26.1616667,2.33466667 L29.357,8.72466667 Z M26.2856667,1.33333333 L5.71433333,1.33333333 C5.41166667,1.33333333 5.13433333,1.50466667 4.999,1.77533333 L1.41766667,8.938 C1.36233333,9.04866667 1.33366667,9.17133333 1.33366667,9.29533333 L1.33366667,29.8666667 C1.33366667,30.3086667 1.69166667,30.6666667 2.13366667,30.6666667 L29.8663333,30.6666667 C30.3083333,30.6666667 30.667,30.3086667 30.667,29.8666667 L30.667,9.29533333 C30.667,9.17133333 30.6376667,9.04866667 30.5823333,8.938 L27.001,1.77533333 C26.8656667,1.50466667 26.5883333,1.33333333 26.2856667,1.33333333 L26.2856667,1.33333333 Z"
                id="Fill-1"
              ></path>
            </g>
          </g></svg
      ></v-tab>
    </v-tabs>
    <v-carousel height="235" hide-delimiters show-arrows-on-hover>
      <v-carousel-item v-for="(image, i) in pkg_images" v-bind:key="i">
        <v-img
          @click="showPhotoSwipe(i)"
          :src="image"
          :lazy-src="image"
          aspect-ratio="1"
          class="grey lighten-2"
        ></v-img>
      </v-carousel-item>
    </v-carousel>
    <v-photoswipe
      :isOpen="isOpen"
      :items="[
        {
          src: pkg_images[0],
          thumbnail: pkg_images[0],
          w: 1200,
          h: 900,
        },
        {
          src: pkg_images[1],
          thumbnail: pkg_images,
          w: 1200,
          h: 900,
        },
      ]"
      :options="options"
      @close="hidePhotoSwipe"
    ></v-photoswipe>

    <!-- <v-img
      src="https://postshipper-images.eu-central-1.linodeobjects.com/images/TNj7GGb2iYLGKxWocYz0AXV8.jpg"
    ></v-img> -->

    <v-container>
      <v-btn
        @click="showPhotoSwipe(1)"
        class="mt-2"
        block
        color="accent"
        outlined
        tile
        >{{ $t("account.more_images") }}</v-btn
      >
    </v-container>

    <!-- <v-card-title
      style="color: #0070eb; font-weight: 700; text-transform: uppercase"
      >{{ info.name }}</v-card-title
    > -->

    <v-card-text>
      <h2 style="font-weight: 700" class="my-2">
        {{ info.name }}
      </h2>
      <div class="subtitle-1">
        <span style="font-weight: light">{{ $t("account.package_id") }}</span>
        <span class="boldnes">{{ info.id }}</span>
      </div>
      <div class="subtitle-1">
        <span style="font-weight: light">{{ $t("account.quantity") }}:</span>
        <span class="boldnes">{{ info.quantity }}</span>
      </div>
      <div class="subtitle-1">
        <span style="font-weight: light">{{
          $t("account.package_originaltrackid")
        }}</span>
        <span class="boldnes">{{ info.original_trackid }}</span>
      </div>
      <div class="subtitle-1">
        <span style="font-weight: light">{{
          $t("account.package_arrived", { days: info.days_left })
        }}</span>
        <!-- Storage: <span class="boldnes">{{ info.days_left }}</span> Days Left -->
      </div>
      <div class="subtitle-1">
        <span style="font-weight: light">{{
          $t("account.package_value")
        }}</span>
        <span v-if="info.price != 0" class="boldnes"
          >{{ info.price
          }}<v-btn v-if="!no_edit" @click="showModal(info.id)" icon
            ><img width="18px" src="../assets/Icons/edit.svg" alt="" /></v-btn
        ></span>
        <v-modal
            v-show="isModalVisible && modalPackageId === info.id"
            @close="closeModal"
            :items="info.packages_items"
        />
        <div v-if="info.price_og == 0">
          <v-btn
              elevation="0"
              class="mt-2 secondary"
              @click="showModal(info.id)"
          >
            {{ $t("custom.add_Prices") }}
          </v-btn
          >
<!--          <v-text-field-->
<!--            type="number"-->
<!--            v-model="price"-->
<!--            label="Price"-->
<!--            outlined-->
<!--          ></v-text-field>-->
<!--          <v-btn-->
<!--            :loading="loader"-->
<!--            @click="addPrice"-->
<!--            block-->
<!--            color="accent"-->
<!--            outlined-->
<!--            >Add Price</v-btn-->
<!--          >-->
        </div>

<!--        <div v-if="editPrice">-->
<!--          <v-text-field-->
<!--            type="number"-->
<!--            v-model="price"-->
<!--            label="Price"-->
<!--            outlined-->
<!--          ></v-text-field>-->
<!--          <v-btn-->
<!--            :loading="loader"-->
<!--            @click="addPrice"-->
<!--            block-->
<!--            color="accent"-->
<!--            outlined-->
<!--            >Update Price</v-btn-->
<!--          >-->
<!--        </div>-->
      </div>
    </v-card-text>

    <v-divider class="mx-4"></v-divider>

    <div style="display: grid" class="my-4">
      <v-alert elevation="0" v-if="!isModalVisible" rounded="0" color="border" style="font-size: 14px">
        <v-row>
          <v-col cols="1"
            ><img src="../assets/Icons/warning.svg" alt="!"
          /></v-col>
          <v-col cols="11" v-html="$t('account.package_info')"></v-col>
        </v-row>
      </v-alert>
    </div>
    <!-- <div class="my-4"></div> -->
  </v-card>
</template>

<script>
import { PhotoSwipe } from "v-photoswipe";
import modal from "@/components/PriceModal.vue";

export default {
  props: ["info", "no_edit", "isModalVisible"],
  components: {
    "v-photoswipe": PhotoSwipe,
    "v-modal": modal,
    // "v-photoswipe-gallery": PhotoSwipeGallery,
  },
  data: () => ({
    isOpen: false,
    isOpenGallery: false,
    options: {
      index: 0,
      closeEl: true,
      captionEl: true,
      fullscreenEl: true,
      zoomEl: true,
      shareEl: true,
      counterEl: true,
      arrowEl: true,
      preloaderEl: true,
      modalPackageId: null
    },
    optionsGallery: {},

    // data props goes here
    editPrice: false,
    pkg_images: null,
    price: 0,
    loader: false,
    zIndex: 0,
    tab: null,
    colors: [
      "indigo",
      "warning",
      "pink darken-2",
      "red lighten-1",
      "deep-purple accent-4",
    ],
    slides: ["First", "Second", "Third", "Fourth", "Fifth"],
  }),
  // computed: {
  //   images(){
  //     let images = [];
  //     images.push(this.info.path_closed_image)
  //     images.push(this.info.images[0].image_link)
  //     this.pkg_images = images;
  //     return images;
  //   }
  // },

  beforeMount() {
    let images = [];
    images.push(this.info.path_closed_image);
    images.push(this.info.images[0].image_link);
    this.pkg_images = images;
  },

  methods: {
    showPhotoSwipe(index) {
      this.isOpen = true;
      this.$set(this.options, "index", index);
    },
    hidePhotoSwipe() {
      this.isOpen = false;
    },
    addPrice() {
      this.loader = true;
      this.$http
        .put("/received/set_package_items_price", {
          package_id: this.info.id,
          price: this.price,
        })
        .then(() => {
          this.loader = false;
          location.reload();
        });
    },
    swapElements() {
      let first = this.pkg_images[1];
      let second = this.pkg_images[0];
      this.pkg_images = [];
      this.pkg_images.push(first);
      this.pkg_images.push(second);
    },
    showModal(package_id) {
      this.$emit('update:isModalVisible', true);
      this.modalPackageId = package_id;
    },
    closeModal() {
      this.$emit('update:isModalVisible', false);
      this.modalPackageId = null;
    }
  },
};
</script>

<style lang="scss" scoped>
.boldnes {
  font-weight: 700;
}

.v-card__text {
  padding: 0 16px;
}

// .v-tab--active,
// .v-tab {
//   color: red;
// }
.v-slide-group__content.v-tabs-slider-wrapper {
  color: #0070eb;

  bottom: 0;
  margin: 0 !important;
  position: absolute;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  z-index: 1;
}
.v-tab.v-tab,
.v-tabs-slider {
  opacity: 50%;
}
.v-tab--active {
  opacity: 100%;
}

.v-tab.v-tab--active,
.v-tabs-slider {
  opacity: 100%;
}

// svg g,
// path {
//   color: #0070eb;
// }
</style>
